"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
const TypographyText = props => {
  const {
    type = 'inherit',
    size = 'inherit',
    strong = false,
    deleted = false,
    italic = false,
    underline = false,
    inline,
    children,
    onClick,
    onMouseDown,
    onMouseUp,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-typography-text");
  return /*#__PURE__*/_react.default.createElement(inline ? 'span' : 'div', {
    ...restProps,
    onClick,
    onMouseDown,
    onMouseUp,
    className: (0, _classnames.default)(baseClassName, "size-".concat(size), "type-".concat(type), {
      strong,
      deleted,
      italic,
      underline,
      clickable: !!onClick || !!onMouseDown || !!onMouseUp
    }, className),
    style
  }, children);
};
var _default = exports.default = TypographyText;